<ng-content></ng-content>

<div class="mt-3">
    <ng-content select="[adaptCallToActionButton]"></ng-content>
    @if (featureUrl) {
        <a [routerLink]="featureUrl">Get started <i class="fal fa-angle-right"></i></a>
    }
</div>
